import React, { useEffect, useState, useRef, useCallback } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import colors from 'Assets/colors'
import ContentLoader from 'react-content-loader'
import moment from 'moment'
import set from 'lodash/set'
import { useParams } from 'react-router'
import find from 'lodash/find'
import get from 'lodash/get'
import { toast } from 'react-toastify'
import isEmpty from 'lodash/isEmpty'
import { useHistory } from 'react-router-dom'
import { DeliveryTypes } from 'Redux/delivery'
import { setProviderOrderForNC } from 'Redux/delivery/actions'
import { selectCenterId } from 'Redux/purchases/utils'
import { PurchaseTypes } from 'Redux/purchases'
import { TicketActions } from 'Redux/ticket'
import routes from 'Config/routes'
import { NOTE_MAX_LENGHT, RECEPTION_COMPLETES_EXCEPTION, RECEPTION_STATUS, MEASURE_UNIT } from 'Config/constants'
import { putDeliveryQa, confirmDelivery, getProviderReceptionOrdersLimitDate, confirmDeliverySQS } from 'Services/api'
import { TextInput, CountInput, ReceptionStatus, NumberFormat } from 'Components/atoms'
import { ModalLoading, ModalError, NoSearch } from 'Components/molecules'
import { selectConfig } from 'Redux/auth/utils'
import Box from '@material-ui/core/Box'
import useCancelOrder from 'hooks/delivery/useCancelOrder'
import useIsMobile from 'hooks/useIsMobile'
import ModalCancelOrder from 'Components/molecules/modalCancelOrder'
import useExtraServiceReception from 'hooks/carts/useReception'
import { isUserSupply } from 'Components/utils/roles'
import SearchIcon from 'Assets/Icons/Search'
import ArrowLeftIcon from 'Assets/Icons/ArrowLeft'
import { ReactComponent as CheckedIcon } from 'Assets/Icons/Checked.svg'
import { ReactComponent as CalendarIcon } from 'Assets/Icons/Calendario.svg'
import { AddCircleOutline } from '@styled-icons/material-outlined/AddCircleOutline'
import { RemoveCircleOutline } from '@styled-icons/material-outlined/RemoveCircleOutline'

import ModalExtraServiceError from './modalExtraServiceError'
import NotServedInfo from './NotServedInfo'
import {
  Container,
  Title,
  TitleWrapper,
  BackButton,
  SubTitle,
  MobileStickyHeader,
  MobileProviderCard,
  MobileProviderCardName,
  MobileProviderCardOrder,
  RequestedContainer,
  SingleRequestedContainer,
  RequestedHeader,
  RequestedHeaderInfo,
  RequestedProviderInfoContainer,
  RequestedProviderInfo,
  RequestedProviderName,
  RequestedProviderDeliveryDate,
  ProviderDetail,
  TotalPrice,
  TotalProductLines,
  ProductsContainer,
  ProductHeader,
  StatusNameComboHeader,
  ProductHeaderItem,
  ProductContainer,
  StatusNameCombo,
  ProductName,
  SingleFieldContainer,
  FixedInputField,
  ActionContainer,
  DateSelectorContainer,
  DatePickerButton,
  DatePickerText,
  FooterInputsRow,
  ProductPriceRow,
  TextInputContainer,
  FinishButtonContainer,
  FinishButton,
  ButtonLiteral,
  TotalsContainer,
  TotalsTotalPrice,
  TotalsTotalItems,
  NumberValueSpan,
  StyledCalendar,
  WarningDateContainer,
  CircularProgressStyled,
  LabelMobile,
  ExtraServiceNameBadge,
  DetailExtraService,
  ExtraServiceRow,
  ExtraServiceLabel,
  ExtraDescWrapper,
  ExtraDesc,
  ExpandToggle,
  SearchAndCounterRow,
  ReviewedCounterWrapper,
  ReviewedProgressTrack,
  ReviewedProgressBar,
  SearchInputWrapper,
  ReviewedCount,
  ReviewedText,
  ReviewCheckWrapper,
  ReviewCheckButton,
  ExtraMobilePrecioRow,
  ExtraMobileDetalleRow,
} from './styled'

const Delivery = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { orderId, documentTypeCode, documentCompany } = useParams()
  const { getDifferenceEstimatedWithReception, validateReception, getIsExtraService } = useExtraServiceReception()

  const itemEls = useRef({})

  const providerOrder = useSelector(({ delivery: deliveryState }) => deliveryState.providerOrder)
  const questionsForm = useSelector(state => state.purchase.qaForm || {})
  const deliveryForm = useSelector(({ delivery: deliveryState }) => deliveryState.deliveryForm)
  const centerId = useSelector(selectCenterId)
  const center = useSelector(state => state.auth.selectedCenter)
  const form = useSelector(({ delivery: deliveryState }) => deliveryState.receptionlines)
  const isLoadingProviderRecivingOrders = useSelector(
    ({ delivery: deliveryState }) => deliveryState.isLoadingProviderRecivingOrders
  )
  const features = useSelector(selectConfig)

  const {
    showCancelOrder,
    cancelOrder,
    blockCancelOrderButtonFromProviderOrder,
    blockCancelOrderButton,
  } = useCancelOrder(providerOrder)

  const user = useSelector(({ auth }) => auth.user)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [totalPrice, setTotalPrice] = useState(null)
  const [showCalendar, setShowCalendar] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [reviewedIds, setReviewedIds] = useState(new Set())
  const [expandedIds, setExpandedIds] = useState(new Set())

  const toggleExpanded = index => {
    setExpandedIds(prev => {
      const next = new Set(prev)
      if (next.has(index)) next.delete(index)
      else next.add(index)
      return next
    })
  }

  const toggleReviewed = index => {
    setReviewedIds(prev => {
      const next = new Set(prev)
      if (next.has(index)) next.delete(index)
      else next.add(index)
      const formCopy = (form || []).map((line, i) => ({ ...line, isReviewed: next.has(i) }))
      dispatch({
        type: DeliveryTypes.PROVIDER_RECIVING_ORDERS_FORM,
        params: {
          orderId,
          form: { receptionlines: formCopy, providerOrder },
          documentTypeCode,
          documentCompany,
        },
      })
      return next
    })
  }

  const [showNotServedModal, setShowNotServedModal] = useState(false)
  const [showCancelOrderModal, setShowCancelOrderModal] = useState(false)

  const [showSubmitErrorModal, setShowSubmitErrorModal] = useState(false)
  const [showExtraServiceErrorModal, setShowExtraServiceErrorModal] = useState(false)
  const [messageErrorModal, setMessageErrorModal] = useState('deliveryError')

  const { lines = [], delivery } = providerOrder
  const isMobile = useIsMobile()
  const { showPrice } = center
  const withProdException = lines.some(prod => prod.price === 0)

  useEffect(() => {
    dispatch({
      type: DeliveryTypes.PROVIDER_RECIVING_ORDERS,
      params: { orderId, documentTypeCode, documentCompany },
    })
    return () => {
      dispatch({
        type: DeliveryTypes.PROVIDER_RECIVING_ORDERS_RESET,
      })
    }
  }, [dispatch, orderId, documentTypeCode, documentCompany])

  useEffect(() => {
    if (lines && lines.length > 0) {
      const total = lines?.reduce((acc, product) => acc + product.price, 0)
      setTotalPrice(total)
    }
  }, [lines])

  useEffect(() => {
    if (form) {
      const total = form?.reduce((acc, newForm) => acc + newForm.amount * newForm.priceUnit, 0)
      setTotalPrice(total)
      setReviewedIds(new Set(form.reduce((acc, line, i) => (line.isReviewed ? [...acc, i] : acc), [])))
    }
  }, [form])

  const [limitDate, setLimitDate] = useState(null)

  useEffect(() => {
    dispatch({
      type: DeliveryTypes.DELIVERY_FORM,
      params: { receptionDate: moment().toDate() },
    })
  }, [dispatch])

  useEffect(() => {
    getProviderReceptionOrdersLimitDate().then(response => {
      setLimitDate(response)
    })
  }, [])

  const handleChange = (index, name, value, line) => {
    const formCopy = [...(form || [])]
    if (name === 'priceUnit' && line && (line?.priceUnit || line?.extraServicePrice)) {
      const { isExtraService, isBigDifference } = getDifferenceEstimatedWithReception(line, value)

      if (isExtraService && isBigDifference && !isUserSupply(user)) {
        set(errors, `receptionlines[${index}].priceUnit`, t('errorBigDifference'))
        setShowExtraServiceErrorModal(true)
      } else {
        set(errors, `receptionlines[${index}]`, null)
      }
    }

    set(formCopy, `[${index}].${name}`, value)
    const formWithReviewed = formCopy.map((item, i) => ({ ...item, isReviewed: reviewedIds.has(i) }))
    dispatch({
      type: DeliveryTypes.PROVIDER_RECIVING_ORDERS_FORM,
      params: {
        orderId,
        form: {
          receptionlines: formWithReviewed,
          providerOrder,
        },
        documentTypeCode,
        documentCompany,
      },
    })
  }

  const handleDeliveryChange = (name, value) => {
    const formCopy = { ...deliveryForm }
    set(formCopy, name, value)
    dispatch({
      type: DeliveryTypes.DELIVERY_FORM,
      params: { ...formCopy },
    })
  }

  const handleOpenNC = useCallback(() => {
    const providerId = providerOrder.provider.id
    dispatch(TicketActions.setIsNotServedOrder(true))
    dispatch(TicketActions.setNonConformityOrder(providerOrder))
    history.push(
      routes.addTicketing(providerId, providerOrder.id, providerOrder.documentTypeCode, providerOrder.documentCompany)
    )
  }, [dispatch, history, providerOrder])

  const ProductLinesPrice = () => {
    const textProduct =
      lines.length === 1
        ? `${lines.length} ${t('product').toLowerCase()}`
        : `${lines.length} ${t('products').toLowerCase()}`
    if (!lines.length) return null
    return <TotalProductLines>{textProduct}</TotalProductLines>
  }

  const handleDeliveryError = error => {
    if (error?.response?.data?.error === RECEPTION_COMPLETES_EXCEPTION && error?.response?.data?.statusCode === 422) {
      toast.info(t('deliveryQaConfirmedError', { id: orderId }))
      history.push(routes.historic)
    } else {
      setMessageErrorModal('deliveryError')
      setShowSubmitErrorModal(true)
      setSubmitLoading(false)
    }
  }

  const handleSubmit = () => {
    const formCopy = [...(form || [])]

    const totalCount = formCopy.reduce((acc, current) => acc + current.amount, 0)

    const payload = { ...deliveryForm, receptionlines: formCopy }
    const submitErrors = validateReception(payload?.receptionlines || [], lines)
    setErrors(submitErrors)

    if (Object.keys(submitErrors).length > 0) {
      setMessageErrorModal('validationDeliveryError')
      setShowSubmitErrorModal(true)
      return null
    }
    if (totalCount > 0) {
      setSubmitLoading(true)
      const ep = features?.order_reception_sqs ? confirmDeliverySQS : confirmDelivery

      ep(centerId, orderId, documentTypeCode, documentCompany, payload)
        .then(() => {
          dispatch({
            type: PurchaseTypes.FETCH_PENDING_PROVIDER_ORDERS,
          })
          if (!isEmpty(questionsForm)) {
            putDeliveryQa(orderId, documentTypeCode, documentCompany, centerId, questionsForm)
              .then(() => {
                dispatch(setProviderOrderForNC(providerOrder))

                history.push(routes.addDeliveryConfirmed(orderId, documentTypeCode, documentCompany))
              })
              .catch(() => {
                toast.error(t('petitionError'))
                setSubmitLoading(false)
              })
          } else {
            dispatch(setProviderOrderForNC(providerOrder))

            history.push(routes.addDeliveryConfirmed(orderId, documentTypeCode, documentCompany))
          }
        })
        .catch(e => {
          handleDeliveryError(e)
        })
    } else {
      setShowNotServedModal(true)
    }
    return null
  }

  const disableCompleteButton = !get(deliveryForm, 'receptionDate') || !get(deliveryForm, 'deliveryNote')

  const handleNext = (id, key, i) => {
    if (!id || !itemEls || !itemEls.current) return

    let index = i

    const currentItem = itemEls.current[index]
    if (!currentItem) return

    if (key === 'amount' && currentItem.priceUnit) {
      currentItem.priceUnit.focus()
    } else {
      if (index >= lines.length - 1) {
        index = 0
      } else {
        index += 1
      }

      const item = itemEls.current[index]
      if (item && item.amount) item.amount.focus()
    }
  }

  const handlePreviuos = (id, key, i) => {
    if (!id || !itemEls || !itemEls.current) return

    let index = i

    const currentItem = itemEls.current[index]
    if (!currentItem) return

    if (key === 'priceUnit' && currentItem.amount) {
      currentItem.amount.focus()
    } else {
      if (index <= 0) {
        index = lines.length - 1
      } else {
        index -= 1
      }

      const item = itemEls.current[index]
      if (key === 'amount' && item.priceUnit) {
        item.priceUnit.focus()
      } else if (item && item.amount) {
        item.amount.focus()
      }
    }
  }

  const handleCancelOrder = useCallback(() => {
    setShowNotServedModal(false)
    setShowCancelOrderModal(true)
  }, [])

  let linesCount = 0

  const hasNoSearchResults =
    !!searchQuery &&
    lines.length > 0 &&
    !lines.some(
      product =>
        product.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        product.extraServiceDescription?.toLowerCase().includes(searchQuery.toLowerCase())
    )

  return (
    <Container>
      <MobileStickyHeader>
        <TitleWrapper>
          <BackButton onClick={() => history.goBack()} aria-label='Volver'>
            <ArrowLeftIcon />
          </BackButton>
          <Title>{t('receptionOrderTitle')}</Title>
        </TitleWrapper>
        <SubTitle>{t('receptionOrderSubtitle')}</SubTitle>
        <MobileProviderCard>
          <MobileProviderCardName>{get(lines, '0.provider.name')}</MobileProviderCardName>
          <MobileProviderCardOrder>
            {t('order')}
            {orderId}
          </MobileProviderCardOrder>
        </MobileProviderCard>
        <SearchAndCounterRow>
          <SearchInputWrapper>
            <TextInput
              placeholder={t('searchByProductName')}
              topIcon='1.2rem'
              width='28rem'
              respWidth='100%'
              Icon={props => <SearchIcon fill={colors.gray40l} {...props} />}
              value={searchQuery}
              onChange={e => setSearchQuery(e?.target?.value ?? '')}
              background={colors.grayInput}
              shadow='none'
              closeIcon
            />
          </SearchInputWrapper>
          <ReviewedCounterWrapper>
            <ReviewedProgressTrack>
              <ReviewedProgressBar
                progress={lines.length > 0 ? `${Math.round((reviewedIds.size / lines.length) * 100)}%` : '0%'}
              />
            </ReviewedProgressTrack>
            <div>
              <ReviewedCount>
                {reviewedIds.size}/{lines.length}
              </ReviewedCount>
              <ReviewedText> {t('reviewedProducts')}</ReviewedText>
            </div>
          </ReviewedCounterWrapper>
        </SearchAndCounterRow>
      </MobileStickyHeader>
      <RequestedContainer>
        {isLoadingProviderRecivingOrders && (!lines || lines.length <= 0) ? (
          <RequestsLoader />
        ) : hasNoSearchResults ? (
          <NoSearch title={t('deliveryNoSearchTitle')} description={t('deliveryNoSearchDescription')} fullWidth />
        ) : (
          <SingleRequestedContainer>
            <RequestedHeader>
              <RequestedHeaderInfo>
                {t('order')}
                {orderId}
              </RequestedHeaderInfo>
              <RequestedHeaderInfo>{moment(providerOrder.created).format('DD/MM/YYYY')}</RequestedHeaderInfo>
            </RequestedHeader>

            <RequestedProviderInfoContainer>
              <RequestedProviderInfo>
                <RequestedProviderName>{get(lines, '0.provider.name')}</RequestedProviderName>
                <RequestedProviderDeliveryDate>
                  {t('historyDeliveryDate')} {moment(delivery).format('DD/MM/YYYY')}
                </RequestedProviderDeliveryDate>
              </RequestedProviderInfo>
              <ProviderDetail>
                {totalPrice && showPrice ? (
                  <TotalPrice>
                    <NumberFormat value={totalPrice} />
                  </TotalPrice>
                ) : null}
                <ProductLinesPrice />
              </ProviderDetail>
            </RequestedProviderInfoContainer>
            <ProductsContainer>
              <ProductHeader>
                <StatusNameComboHeader>
                  <ProductHeaderItem>{t('status')}</ProductHeaderItem>
                  <ProductHeaderItem>{t('product')}</ProductHeaderItem>
                </StatusNameComboHeader>

                <ProductHeaderItem>{t('orderQty')}</ProductHeaderItem>
                <ProductHeaderItem>{t('recievedQty')}</ProductHeaderItem>
                {withProdException || showPrice ? (
                  <ProductHeaderItem>{t('price')}</ProductHeaderItem>
                ) : (
                  <ProductHeaderItem />
                )}
                {withProdException || showPrice ? (
                  <ProductHeaderItem>{t('sum')}</ProductHeaderItem>
                ) : (
                  <ProductHeaderItem />
                )}
                <ProductHeaderItem style={{ textAlign: 'center', paddingLeft: 0 }}>{t('revision')}</ProductHeaderItem>
              </ProductHeader>
              {form &&
                lines.map((product, index) => {
                  const { status, name, measureUnit, amount, reference, id, extraServiceDescription, price } = product
                  const matchesSearch =
                    !searchQuery ||
                    name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    extraServiceDescription?.toLowerCase().includes(searchQuery.toLowerCase())
                  if (!matchesSearch) return null
                  const itemForm = find(form, { id: reference, documentLineNumber: product.documentLineNumber })
                  if (!itemForm) return null
                  const { amount: amountReceived, priceUnit } = itemForm

                  const lineIndex = linesCount
                  linesCount += 1
                  const productDetail = getIsExtraService(get(lines, `[${index}]`)) ? ` ${extraServiceDescription}` : ''

                  if (isMobile && productDetail) {
                    return (
                      <ProductContainer
                        key={`${reference}_${id}_${lineIndex}`}
                        isExtraService
                        expanded={expandedIds.has(index)}
                      >
                        <StatusNameCombo isExtraService>
                          <ReceptionStatus newStatus={status} />
                          <SingleFieldContainer>
                            <ExtraServiceNameBadge>{name}</ExtraServiceNameBadge>
                          </SingleFieldContainer>
                        </StatusNameCombo>

                        <SingleFieldContainer inline>
                          <LabelMobile>{t('orderQty')}:</LabelMobile>
                          <FixedInputField>
                            <NumberFormat value={amount} color={colors.black} /> &nbsp;{measureUnit}
                          </FixedInputField>
                        </SingleFieldContainer>

                        <SingleFieldContainer isExtraService>
                          <LabelMobile>{t('recievedQty')}:</LabelMobile>
                          <FixedInputField>
                            {amountReceived} &nbsp;{measureUnit}
                          </FixedInputField>
                        </SingleFieldContainer>

                        {showPrice && (
                          <SingleFieldContainer>
                            <LabelMobile>{t('price')}</LabelMobile>
                            <CountInput
                              value={priceUnit}
                              unit={`€/${measureUnit}`}
                              onChange={e => handleChange(index, 'priceUnit', e, lines[index])}
                              format='float'
                              background={colors.grayInputEditable}
                              fontWeight='400'
                              fontSize='16px'
                              lineHeight='24px'
                              letterSpacing='0.15px'
                              inputColor='#00000099'
                              height='40px'
                              border='none'
                              paddingLeft='0'
                              error={
                                errors?.receptionlines?.length > index && errors?.receptionlines?.[index]?.priceUnit
                                  ? true
                                  : undefined
                              }
                              innerRef={element => {
                                if (element) {
                                  itemEls.current[lineIndex] = itemEls.current[lineIndex] || {}
                                  itemEls.current[lineIndex].priceUnit = element
                                  itemEls.current[lineIndex].index = lineIndex
                                }
                              }}
                              onPrevious={() => handlePreviuos(reference, 'priceUnit', lineIndex)}
                              onNext={() => handleNext(reference, 'priceUnit', lineIndex)}
                              min={amount < 0 ? null : 0}
                            />
                          </SingleFieldContainer>
                        )}

                        <ExtraMobilePrecioRow>
                          <div>
                            <ExtraServiceLabel>Precio original</ExtraServiceLabel>
                            <NumberFormat
                              value={price}
                              suffix={`€/${measureUnit}`}
                              color={colors.black}
                              style={{
                                fontFamily: 'Inter',
                                fontWeight: 600,
                                fontSize: '14px',
                                lineHeight: '16px',
                                letterSpacing: '0px',
                              }}
                            />
                          </div>
                          {(showPrice || get(lines, `[${index}].price`) === 0) && (
                            <div>
                              <ExtraServiceLabel>Importe total</ExtraServiceLabel>
                              <NumberFormat
                                value={priceUnit * amountReceived}
                                color={colors.black}
                                style={{
                                  fontFamily: 'Inter',
                                  fontWeight: 600,
                                  fontSize: '14px',
                                  lineHeight: '16px',
                                  letterSpacing: '0px',
                                }}
                              />
                            </div>
                          )}
                        </ExtraMobilePrecioRow>

                        {extraServiceDescription && (
                          <ExtraMobileDetalleRow>
                            <ExtraServiceLabel>Detalle</ExtraServiceLabel>
                            <ExtraDescWrapper>
                              <ExtraDesc expanded={expandedIds.has(index)}>{extraServiceDescription}</ExtraDesc>
                              <ExpandToggle onClick={() => toggleExpanded(index)}>
                                {expandedIds.has(index) ? (
                                  <RemoveCircleOutline size={20} />
                                ) : (
                                  <AddCircleOutline size={20} />
                                )}
                              </ExpandToggle>
                            </ExtraDescWrapper>
                          </ExtraMobileDetalleRow>
                        )}

                        <ReviewCheckWrapper isExtraService>
                          <LabelMobile>{t('revision')}</LabelMobile>
                          <ReviewCheckButton checked={reviewedIds.has(index)} onClick={() => toggleReviewed(index)}>
                            {reviewedIds.has(index) && <CheckedIcon />}
                          </ReviewCheckButton>
                        </ReviewCheckWrapper>
                      </ProductContainer>
                    )
                  }

                  return (
                    <ProductContainer key={`${reference}_${id}_${lineIndex}`} expanded={expandedIds.has(index)}>
                      <StatusNameCombo isExtraService={!!productDetail}>
                        <ReceptionStatus newStatus={status} />
                        <SingleFieldContainer>
                          {productDetail ? (
                            <ExtraServiceNameBadge>{name}</ExtraServiceNameBadge>
                          ) : (
                            <ProductName>{name}</ProductName>
                          )}
                          {productDetail && (
                            <DetailExtraService>
                              <ExtraServiceRow>
                                <ExtraServiceLabel>Precio original</ExtraServiceLabel>
                                <NumberFormat
                                  value={price}
                                  suffix={`€/${measureUnit}`}
                                  color={colors.black}
                                  style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    lineHeight: '16px',
                                    letterSpacing: '0px',
                                  }}
                                />
                              </ExtraServiceRow>
                              {extraServiceDescription && (
                                <ExtraServiceRow>
                                  <ExtraServiceLabel>Detalle</ExtraServiceLabel>
                                  <ExtraDescWrapper>
                                    <ExtraDesc expanded={expandedIds.has(index)}>{extraServiceDescription}</ExtraDesc>
                                    <ExpandToggle onClick={() => toggleExpanded(index)}>
                                      {expandedIds.has(index) ? (
                                        <RemoveCircleOutline size={20} />
                                      ) : (
                                        <AddCircleOutline size={20} />
                                      )}
                                    </ExpandToggle>
                                  </ExtraDescWrapper>
                                </ExtraServiceRow>
                              )}
                            </DetailExtraService>
                          )}
                        </SingleFieldContainer>
                      </StatusNameCombo>
                      <SingleFieldContainer inline>
                        <LabelMobile>{t('orderQty')}:</LabelMobile>

                        <FixedInputField>
                          <NumberFormat value={amount} color={colors.black} /> &nbsp;
                          {measureUnit}
                        </FixedInputField>
                      </SingleFieldContainer>

                      {status !== RECEPTION_STATUS.FT && !extraServiceDescription ? (
                        <Box>
                          <LabelMobile>{t('recievedQty')}</LabelMobile>

                          <CountInput
                            amountOrdered={amount}
                            value={amountReceived}
                            unit={measureUnit}
                            onChange={e => handleChange(index, 'amount', e)}
                            format={measureUnit === MEASURE_UNIT.KG ? 'float' : 'int'}
                            background={colors.grayInputEditable}
                            fontWeight={isMobile ? '400' : '600'}
                            fontSize={isMobile ? '16px' : undefined}
                            lineHeight={isMobile ? '24px' : undefined}
                            letterSpacing={isMobile ? '0.15px' : undefined}
                            inputColor={isMobile ? '#00000099' : undefined}
                            border='none'
                            height='40px'
                            innerRef={element => {
                              if (element) {
                                itemEls.current[lineIndex] = itemEls.current[lineIndex] || {}
                                itemEls.current[lineIndex].amount = element
                                itemEls.current[lineIndex].index = lineIndex
                              }
                            }}
                            onPrevious={() => handlePreviuos(reference, 'amount', lineIndex)}
                            onNext={() => handleNext(reference, 'amount', lineIndex)}
                            min={amount < 0 ? null : 0}
                          />
                        </Box>
                      ) : (
                        <SingleFieldContainer isExtraService={!!productDetail}>
                          <LabelMobile>
                            {t('recievedQty')}
                            {productDetail ? ':' : ''}
                          </LabelMobile>

                          <FixedInputField>
                            {amountReceived} &nbsp;
                            {measureUnit}
                          </FixedInputField>
                        </SingleFieldContainer>
                      )}

                      <ProductPriceRow expanded={expandedIds.has(index)}>
                        <SingleFieldContainer>
                          <LabelMobile>{t('price')}</LabelMobile>

                          {get(lines, `[${index}].priceUnit`) &&
                            !get(lines, `[${index}].extraServiceDescription`) &&
                            showPrice && (
                              <FixedInputField>
                                <NumberFormat value={priceUnit} suffix={`€/${measureUnit}`} color={colors.black} />
                              </FixedInputField>
                            )}
                          {getIsExtraService(get(lines, `[${index}]`)) &&
                            !get(lines, `[${index}].extraServiceDescription`) &&
                            showPrice && (
                              <FixedInputField>
                                <NumberFormat value={priceUnit} suffix={`€/${measureUnit}`} color={colors.black} />
                              </FixedInputField>
                            )}
                          {(!get(lines, `[${index}].priceUnit`) || get(lines, `[${index}].extraServiceDescription`)) &&
                            showPrice && (
                              <CountInput
                                value={priceUnit}
                                unit={`€/${measureUnit}`}
                                onChange={e => handleChange(index, 'priceUnit', e, lines[index])}
                                format='float'
                                background={colors.grayInputEditable}
                                fontWeight='600'
                                height='40px'
                                border='none'
                                paddingLeft='0'
                                error={
                                  errors?.receptionlines?.length > index && errors?.receptionlines?.[index]?.priceUnit
                                    ? true
                                    : undefined
                                }
                                innerRef={element => {
                                  if (element) {
                                    itemEls.current[lineIndex] = itemEls.current[lineIndex] || {}
                                    itemEls.current[lineIndex].priceUnit = element
                                    itemEls.current[lineIndex].index = lineIndex
                                  }
                                }}
                                onPrevious={() => handlePreviuos(reference, 'priceUnit', lineIndex)}
                                onNext={() => handleNext(reference, 'priceUnit', lineIndex)}
                                // onBlur={() => handleBlur(index, 'priceUnit', lines[index], priceUnit)}
                                min={amount < 0 ? null : 0}
                              />
                            )}
                        </SingleFieldContainer>
                        <SingleFieldContainer>
                          <LabelMobile>{t('sum')}</LabelMobile>

                          {showPrice || get(lines, `[${index}].price`) === 0 ? (
                            <FixedInputField>
                              <NumberFormat value={priceUnit * amountReceived} color={colors.black} />
                            </FixedInputField>
                          ) : null}
                        </SingleFieldContainer>
                      </ProductPriceRow>
                      <ReviewCheckWrapper isExtraService={!!productDetail}>
                        <LabelMobile>{t('revision')}</LabelMobile>
                        <ReviewCheckButton checked={reviewedIds.has(index)} onClick={() => toggleReviewed(index)}>
                          {reviewedIds.has(index) && <CheckedIcon />}
                        </ReviewCheckButton>
                      </ReviewCheckWrapper>
                    </ProductContainer>
                  )
                })}
            </ProductsContainer>
          </SingleRequestedContainer>
        )}
      </RequestedContainer>

      <ActionContainer>
        <FooterInputsRow>
          <DateSelectorContainer>
            <DatePickerButton onClick={() => setShowCalendar(!showCalendar)}>
              <CalendarIcon fill={colors.textSecondary} />
              <DatePickerText hasValue={!!get(deliveryForm, 'receptionDate')}>
                {get(deliveryForm, 'receptionDate')
                  ? moment(get(deliveryForm, 'receptionDate')).format('DD/MM/YYYY')
                  : t('fechaRecepcion')}
              </DatePickerText>
            </DatePickerButton>
            {limitDate && moment(get(deliveryForm, 'receptionDate')) < moment(limitDate.limitReceptionDate) ? (
              <WarningDateContainer>{t('invalidSelectDate')}</WarningDateContainer>
            ) : null}
            {showCalendar && limitDate && (
              <StyledCalendar
                formatShortWeekday={(locale, date) => moment(date).format('ddd')[0]}
                formatMonthYear={(locale, date) => moment(date).format('MMMM YYYY')}
                value={get(deliveryForm, 'receptionDate')}
                selectRange={false}
                minDate={moment(limitDate.limitReceptionDate).toDate()}
                maxDate={moment().toDate()}
                onChange={value => {
                  setShowCalendar(false)
                  handleDeliveryChange('receptionDate', value)
                }}
              />
            )}
          </DateSelectorContainer>
          <TextInputContainer>
            <TextInput
              placeholder={t('nDeAlbaran')}
              value={get(deliveryForm, 'deliveryNote')}
              onChange={e => handleDeliveryChange('deliveryNote', e.target.value)}
              background={colors.grayInputEditable}
              border='none'
              shadow='none'
              height='44px'
              width='196px'
              respWidth='100%'
              fontFamily='Inter'
              fontWeight='400'
              letterSpacing='0.15px'
              color={get(deliveryForm, 'deliveryNote') ? colors.textPrimary : colors.textSecondary}
              placeholderColor={colors.textSecondary}
              maxLength={NOTE_MAX_LENGHT}
            />
          </TextInputContainer>
        </FooterInputsRow>
        <FinishButtonContainer>
          <FinishButton onClick={handleSubmit} disabled={disableCompleteButton || submitLoading}>
            {disableCompleteButton ? (
              <ButtonLiteral disabled>
                {submitLoading && <CircularProgressStyled size={16} />}
                {t('fillAllOut')}
              </ButtonLiteral>
            ) : (
              <ButtonLiteral>
                {submitLoading && <CircularProgressStyled size={16} />}
                {t('confirmReception')}
              </ButtonLiteral>
            )}

            <TotalsContainer>
              {showPrice ? (
                <TotalsTotalPrice disabled={disableCompleteButton || submitLoading}>
                  <NumberValueSpan disabled={disableCompleteButton || submitLoading}>
                    <NumberFormat
                      value={totalPrice}
                      color={disableCompleteButton || submitLoading ? colors.black : colors.white}
                    />
                  </NumberValueSpan>
                </TotalsTotalPrice>
              ) : null}
              <TotalsTotalItems>{lines.length}</TotalsTotalItems>
            </TotalsContainer>
          </FinishButton>
        </FinishButtonContainer>
      </ActionContainer>
      <ModalLoading showModal={submitLoading} />
      <ModalExtraServiceError
        showModal={showExtraServiceErrorModal}
        title={t('esDifPrice')}
        color='red'
        message={t('esDifPriceDesc')}
        height='250px'
        onConfirm={() => setShowExtraServiceErrorModal(false)}
        setShowModal={() => setShowExtraServiceErrorModal(false)}
      />
      <ModalError
        showModal={showSubmitErrorModal}
        title={t('deliveryErrorTitle')}
        color='red'
        message={t(messageErrorModal)}
        height='300px'
        onConfirm={() => setShowSubmitErrorModal(false)}
        setShowModal={() => setShowSubmitErrorModal(false)}
      />
      <NotServedInfo
        showModal={showNotServedModal}
        setShowModal={setShowNotServedModal}
        width='700px'
        height='300px'
        onConfirm={handleOpenNC}
        onCancelOrder={handleCancelOrder}
        canCancelOrder={showCancelOrder}
        hideOpenNC={blockCancelOrderButtonFromProviderOrder || blockCancelOrderButton}
      />
      <ModalCancelOrder
        showModal={showCancelOrderModal}
        setShowModal={setShowCancelOrderModal}
        onConfirm={cancelOrder}
        order={providerOrder}
        borderRadius='4px'
        bottomBackground='#E7E7E7'
      />
    </Container>
  )
}

const RequestsLoader = () => {
  const { t } = useTranslation()

  return (
    <ContentLoader
      speed={2}
      width={1400}
      height={232}
      viewBox='0 0 1400 232'
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'
      title={t('loading')}
    >
      <rect x='18' y='60' rx='0' ry='0' width='700' height='10' />
      <rect x='18' y='18' rx='0' ry='0' width='150' height='10' />
      <rect x='18' y='110' rx='0' ry='0' width='100' height='10' />
      <rect x='400' y='110' rx='0' ry='0' width='100' height='10' />
      <rect x='18' y='142' rx='0' ry='0' width='700' height='10' />
    </ContentLoader>
  )
}

export default Delivery
